export default __webpack_public_path__ + "static/media/Bestyrelse.80548061.jpg";